import { useI18n } from '@affine/i18n';
import { DocService, useService } from '@toeverything/infra';

import { TagsInlineEditor } from '../../tags-inline-editor';
import * as styles from '../styles.css';

export const TagsValue = () => {
  const doc = useService(DocService).doc;

  const t = useI18n();

  return (
    <TagsInlineEditor
      className={styles.propertyRowValueCell}
      placeholder={t['com.affine.doc-properties.property-value-placeholder']()}
      pageId={doc.id}
      readonly={doc.blockSuiteDoc.readonly}
    />
  );
};
